import React, { Dispatch, SetStateAction } from 'react';
import defaultTo from 'lodash/defaultTo';
import { Popup } from '@atlaskit/popup';

import { Box, xcss } from '@atlaskit/primitives';

const contentStyles = xcss({
  padding: 'space.150',
  maxWidth: '400px',
});

export const ALL_CURRENCY_FILTER_TYPE = 'Currency';
export const FILTER_TYPE_ALL = 'All';

export enum Currency {
  JPY = 'JPY',
  USD = 'USD',
}

export enum Country {
  JP = 'JP',
  US = 'US',
}

export const currencyMap: { [key: string]: string } = {
  JP: Currency.JPY,
  US: Currency.USD,
};

export const getCurrencyByCountry = (countryCode?: string | null): string => {
  if (countryCode) {
    return currencyMap[countryCode] || Currency.USD;
  }
  return '';
};

export const getReadMoreDialog = (
  message: JSX.Element,
  isOpen: boolean,
  setIsOpen: Dispatch<SetStateAction<boolean>>
) => {
  return (
    <div data-testid="popup-modal-overlay">
      <Popup
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        placement="bottom-start"
        zIndex={999}
        content={() => {
          return (
            <Box xcss={contentStyles} testId="invoice-details-popup-content">
              {' '}
              <div className="inline-content-dialog-message">{message}</div>
            </Box>
          );
        }}
        trigger={(triggerProps) => (
          <a {...triggerProps} onClick={() => setIsOpen(!isOpen)}>
            {' '}
            Read more
          </a>
        )}
      />
    </div>
  );
};

export const currencyDecimalFormatter: { [key: string]: number } = {
  JPY: 1,
  USD: 100,
};

export const minimumFractionDigitsMap: { [key: string]: number } = {
  JPY: 0,
  USD: 2,
};

export const getFormattedAmountByCurrency = (amount: number, currency?: string | null) => {
  currency = currency || Currency.USD;
  return amount / currencyDecimalFormatter[currency];
};

export const getDenominatorByCurrency = (currency?: string | null) => {
  currency = currency || Currency.USD;
  return currencyDecimalFormatter[currency];
};

export const getMinimumFractionDigitsByCurrency = (currency?: string | null) => {
  currency = currency ?? Currency.USD;
  return { minimumFractionDigits: defaultTo(minimumFractionDigitsMap[currency], 2) };
};
